import React from "react";
import "./paragraph.scss";

export const Paragraph = ({ children, className = "" }) => {
  return <div className={`paragraph-container ${className}`}>{children}</div>;
};
